import { useState, type FormEvent } from "react";

const FORM_ADDR = "https://readdy.ai/api/form/daeo9jjep053ijub1f70";

export default function SubscribeSection() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [msg, setMsg] = useState("");

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = ((fd.get("website_alt") as string) || "").trim();
    const email = (fd.get("email") as string) || "";

    if (honeypot) {
      setStatus("success");
      setMsg("订阅成功，我们会第一时间推送最新事件复盘。");
      form.reset();
      return;
    }
    if (!email) {
      setStatus("error");
      setMsg("请填写正确的邮箱地址。");
      return;
    }
    if (honeypot === "") fd.delete("website_alt");

    setStatus("loading");
    setMsg("");
    try {
      const res = await fetch(FORM_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed: any = null;
      try {
        parsed = text ? JSON.parse(text) : null;
      } catch {
        parsed = null;
      }
      const code = parsed?.code;
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      if (res.ok && code === "OK") {
        setStatus("success");
        setMsg("订阅成功，我们会第一时间推送最新事件复盘。");
        form.reset();
      } else {
        setStatus("error");
        setMsg(serverMsg && /spam/.test(serverMsg) ? "提交异常，请稍后再试。" : serverMsg || "提交失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMsg("网络异常，请稍后再试。");
    }
  }

  return (
    <section id="subscribe" className="scroll-mt-24 w-full">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6 py-16 md:py-20">
        <div className="relative overflow-hidden rounded-3xl bg-primary-600 p-7 md:p-12">
          <div className="pointer-events-none absolute -right-16 -top-20 h-64 w-64 rounded-full bg-primary-500/60 blur-2xl"></div>
          <div className="pointer-events-none absolute -bottom-24 left-1/3 h-72 w-72 rounded-full bg-accent-600/40 blur-3xl"></div>

          <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-medium text-background-50">
                <i className="ri-notification-3-line"></i> 免费订阅热榜
              </span>
              <h2 className="font-heading mt-4 text-2xl md:text-3xl font-bold text-background-50 leading-snug">
                热门事件更新，第一时间送达你的邮箱
              </h2>
              <p className="mt-3 text-background-100/90 text-sm md:text-base">
                订阅后，当重要事件出现新节点或新增深度复盘，我们会及时提醒你。随时可退订。
              </p>
            </div>

            <form
              data-readdy-form
              onSubmit={handleSubmit}
              className="rounded-2xl bg-background-50 p-6 md:p-7 shadow-lg"
              noValidate
            >
              <label htmlFor="sub-name" className="text-sm font-medium text-foreground-800">
                你的称呼 <span className="text-primary-500">*</span>
              </label>
              <input
                id="sub-name"
                name="name"
                type="text"
                required
                className="mt-2 w-full rounded-xl border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
                placeholder="例如：小瓜"
              />

              <label htmlFor="sub-email" className="mt-4 block text-sm font-medium text-foreground-800">
                邮箱地址 <span className="text-primary-500">*</span>
              </label>
              <input
                id="sub-email"
                name="email"
                type="email"
                required
                className="mt-2 w-full rounded-xl border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
                placeholder="you@example.com"
              />

              <label htmlFor="sub-interest" className="mt-4 block text-sm font-medium text-foreground-800">
                你常关注的内容（可选）
              </label>
              <select
                id="sub-interest"
                name="interest"
                className="mt-2 w-full cursor-pointer rounded-xl border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400"
                defaultValue=""
              >
                <option value="" disabled>
                  选择偏好栏目
                </option>
                <option value="ent">娱乐瓜田</option>
                <option value="biz">商业动向</option>
                <option value="tech">科技观察</option>
                <option value="culture">文化现象</option>
                <option value="all">全部内容</option>
              </select>

              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="hp-field"
              />

              <button
                type="submit"
                disabled={status === "loading"}
                className="mt-6 inline-flex w-full cursor-pointer items-center justify-center gap-2 rounded-xl bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-60 whitespace-nowrap"
              >
                {status === "loading" ? "提交中…" : "订阅最新瓜讯"} <i className="ri-arrow-right-line"></i>
              </button>

              {status === "success" && (
                <p className="mt-4 flex items-start gap-2 rounded-xl bg-accent-100 px-4 py-3 text-sm text-accent-800">
                  <i className="ri-checkbox-circle-line text-base"></i> {msg}
                </p>
              )}
              {status === "error" && (
                <p className="mt-4 flex items-start gap-2 rounded-xl bg-primary-100 px-4 py-3 text-sm text-primary-800">
                  <i className="ri-error-warning-line text-base"></i> {msg}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}